import React from 'react';
import { isLpgProductId } from '../../../../shared/offer-domain/constants';
import CounterOfferModalLpg from './lpg/CounterOfferModalLpg';
import CounterOfferModalNonLpg from './nonLpg/CounterOfferModalNonLpg';

const CounterOfferModal = props => {
  const isLpgProduct = isLpgProductId(props.form?.productNameId);

  if (isLpgProduct) {
    return <CounterOfferModalLpg {...props} />;
  }

  return <CounterOfferModalNonLpg {...props} />;
};

export default CounterOfferModal;
